import type { TypedDocumentNode } from '@urql/core';

import { gql } from '@/shared/types/gql';

import type { IntegrationConnectionsQuery, IntegrationConnectionsVars } from '../types';

/**
 * Every catalog service with the caller's status (`filter: ALL`), so a service the user may not
 * connect carries its `reason`. `connector.provider` picks the Google behaviour of the AI CIO
 * Connect card (CC D15) and keys the result copy (`results.ts`).
 */
export const INTEGRATION_CONNECTIONS: TypedDocumentNode<
  IntegrationConnectionsQuery,
  IntegrationConnectionsVars
> = gql`
  query IntegrationConnections {
    investbanq {
      integrations {
        connections(filter: ALL) {
          service
          entitled
          connected
          status
          reason
          statusChangedAt
          display
          connector {
            name
            provider
            providerName
            description
            logo {
              key
              brandColor
            }
          }
        }
      }
    }
  }
`;
